import hireAxios from "../../axios/hireAxios";

export const submitHiringRequestApi = async (payload) => {
  try {
    const response = await hireAxios.post(
      "enterprise/hiring-requests",
      payload
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
